// extracted by mini-css-extract-plugin
module.exports = {"container":"GenericCard_container__3fc16","head":"GenericCard_head__3HgML"};